import './App.css';
import View360 from './Components/View360/View360';
import { BrowserRouter, Routes, Route } from "react-router-dom";
function App() {
  return (
    <div className="App">
      
      <BrowserRouter>
        <Routes>
            <Route path="/360" element={<View360 />}></Route>
        </Routes>
      </BrowserRouter>
      {/* <View360/> */}      
    </div>
  );
}

if (window.addEventListener) {
  window.addEventListener("message", handleMessage);
} else {
  window.attachEvent("onmessage", handleMessage);
}

function handleMessage(event) {
  if(event['data'] && event['data']['hotspot_id'] && event['data']['image_id'] >=0 ){
    //console.log("inside ifram", event);
    window.View360Reference.handleExternalHotSpotClick(event['data']['image_id'], event['data']['hotspot_id'], event['data']['keyobj'], event['data']['index']);
  }

  if(event['data'] && event['data']['closeMe']){
    window.View360Reference.handleExternalClose();
  }
}


export default App;